(function () {
	'use strict';
	var controllerId = 'elencoAmici';
	angular.module('app').controller(controllerId, ['$scope', 'datacontext', '_', 'common', '$uibModalInstance', 'amici', '$translate', elencoAmiciFn]);

	function elencoAmiciFn($scope, datacontext, _, common, $uibModalInstance, amici, $translate) {
		var getLogFn = common.logger.getLogFn;
		var log = getLogFn(controllerId);
		var logError = getLogFn(controllerId, "logError");
		var logSuccess = getLogFn(controllerId, "logSuccess");

		$scope.list = {};
		$scope.list.amici = amici;
		$scope.item = {};
		$scope.item.view = 'list';

		$scope.back = function () {
			$scope.docente = {};
			$scope.item.view = 'list';
		}

		$scope.detail = function (o) {
		    $scope.docente = o;
		    datacontext.materia_getAllByDocenteId($scope.docente.Id).then(function (materie) {
		        datacontext.classe_getAllByDocenteId($scope.docente.Id).then(function (classi) {
		            $scope.docente.classi = _.uniq(classi, 'Grado');
		        });
		        $scope.docente.materie = materie;
		    });
			$scope.item.view = 'detail';
		}

		$scope.cancel = function () {
			$uibModalInstance.dismiss();
		};

		$scope.cancellaAmicizia = function () {
		    datacontext.community_getAmicizia($scope.docente.Id).then(function (data) {
				datacontext.community_deleteAmicizia(data.Id).then(function (data) {
					if (data == '200') {
					    logSuccess($translate.instant('AmiciziaCancellata'));
						$uibModalInstance.close();
					}
					else
					    logError($translate.instant('ErroreElaborazioneRichiesta'));
				});
			});
		}
	}
})();